import { dropBoolean, dropStatusAnuncio } from 'utils/drops';

const getAnunciosFilterFields = (drops = {}) => [
  { name: 'id', label: 'ID', type: 'number' },
  {
    name: 'marketplace',
    label: 'Marketplace',
    type: 'select',
    options: drops?.IntegraAccess,
    multiple: true,
  },
  { name: 'anuncio', label: 'Título', initial: true },
  { name: 'codigo', label: 'Código' },
  {
    name: 'ativo',
    label: 'Status',
    type: 'select',
    options: dropStatusAnuncio,
  },
  {
    name: 'produto',
    label: 'Produto',
    type: 'virtual-select',
    options: drops?.Produto?.filter((produto) =>
      [
        '00-Mercadoria para revenda',
        '04-Produto acabado',
        '05-Subproduto',
        '06-Produto intermediário',
      ]?.includes(produto?.tipolinha)
    ),
    multiple: true,
  },
  { name: 'referencia', label: 'Referência' },
  { name: 'preco', label: 'Preço', type: 'currency' },
  { name: 'estoque', label: 'Estoque', type: 'currency' },
  {
    name: 'reserva',
    label: 'Reserva',
    type: 'select',
    options: dropBoolean,
  },
];

export default getAnunciosFilterFields;
